export enum ReloadMethodEnum {
  METHOD_1 = 'METHOD_1',
  METHOD_2 = 'METHOD_2',
}

export namespace ReloadMethodEnum {

  export const valueOf = (reloadMethod?: string): ReloadMethodEnum | undefined => {
    try {
      return reloadMethod != null ? ReloadMethodEnum[reloadMethod] : undefined
    } catch(e) {
      return undefined
    }
  }
}